export const normalizeString = (value: string | number | boolean): string => {
  return value.toString().normalize('NFKD').trim().toUpperCase();
};
